import Component from '@component';

export default class SignInEventPostConnect extends Component {
	onInit() {
		const signInEvent = {};
		signInEvent.event = 'sign_in';
		signInEvent.method = 'email';

		if (window.sessionStorage.getItem('userSignIn') === 'yes') {
			window.sessionStorage.removeItem('userSignIn');
			dataLayer.push(signInEvent);
		}
	}
}
